import { logger } from '@/utils/logger';

/**
 * Iframe滚动管理器
 * 负责管理向iframe发送滚动指令
 */
export class IframeScrollManager {
  constructor(messageSender) {
    this.messageSender = messageSender;
  }

  /**
   * 发送滚动到底部指令
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} conversationId - 会话ID
   */
  sendScrollToBottom(iframe, conversationId) {
    if (!iframe || !iframe.contentWindow) {
      logger.error('[IframeScrollManager] iframe不存在或未正确配置');
      return;
    }

    try {
      // 直接发送滚动消息，避免重复调用
      const messageData = {
        type: 'SCROLL_TO_BOTTOM',
        data: {},
      };
      iframe.contentWindow.postMessage(messageData, '*');

      logger.debug('会话切换：已发送滚动到底部指令到子窗体', {
        conversationId,
      });
    } catch (error) {
      logger.error('会话切换：发送滚动到底部指令失败', {
        conversationId,
        error: error.message,
      });
    }
  }

  /**
   * 在会话切换成功后自动滚动到底部
   * @param {string} conversationId - 会话ID
   */
  autoScrollToBottomAfterSwitch(conversationId) {
    logger.debug('[IframeScrollManager] 开始自动滚动到底部', {
      conversationId,
    });

    const iframe = document.querySelector('iframe');
    if (iframe) {
      logger.debug('[IframeScrollManager] 找到iframe元素，开始发送滚动指令');
      this.sendScrollToBottom(iframe, conversationId);
    } else {
      logger.warn('[IframeScrollManager] 未找到iframe元素，无法发送滚动指令');
    }
  }
}
